export const storeIds = [1, 3, 11, 12, 18, 19, 20, 21, 22, 25, 26];



